export interface Env {
  NEXT_PUBLIC_EXTERNAL_API_URL?: string;
  NEXT_PUBLIC_FRONTEND_URL?: string;
}

export async function getEnv(): Promise<Env> {
  try {
    const res = await fetch("/api/env", { cache: "no-store" });
    if (!res.ok) return {};
    const json = (await res.json()) as Env;
    return json ?? {};
  } catch {
    return {};
  }
}


